module.exports = __webpack_public_path__ + "static/img/18.82fee0e9.png";